export const baseUrl = 'https://eweb8.vfd2-testnet.de';
export const baseUserInfoUrl = 'https://api.vodafone.de';
export const mintApi = '/mint/oidc/authorize';
export const tokenApi = '/mint/oidc/token';
export const userInfoApi = '/onlineshop/v1/tmf-api/openid/v4/userinfo';
